var _rect, _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarouselItem2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 136,
    viewBox: "0 0 194 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 66,
    width: 51,
    height: 51,
    rx: 25.5,
    transform: "rotate(90 79 66)",
    fill: "#F2E9FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.601 34.509C145.051 34.6737 145.05 35.326 144.601 35.4905C138.726 37.6413 136.641 39.7253 134.49 45.6008C134.326 46.0502 133.674 46.0504 133.509 45.601C131.357 39.7277 129.274 37.6438 123.399 35.491C122.949 35.3263 122.95 34.674 123.399 34.5095C129.274 32.3587 131.359 30.2747 133.51 24.3992C133.674 23.9498 134.326 23.9496 134.491 24.399C136.643 30.2723 138.726 32.3562 144.601 34.509Z",
    fill: "url(#paint0_linear_26951_23032)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.5,
    cy: 20.5,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(90 35.5 20.5)",
    fill: "#00FFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.857 34.5714H70.9999C66.8972 34.5714 63.5713 31.2455 63.5713 27.1428C63.5713 23.0401 66.8972 19.7142 70.9999 19.7142H85.857C89.9597 19.7142 93.2856 23.0401 93.2856 27.1428C93.2856 31.2455 89.9597 34.5714 85.857 34.5714Z",
    stroke: "url(#paint1_linear_26951_23032)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.143 77.2856H130.429",
    stroke: "url(#paint2_linear_26951_23032)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.143 95.8571H130.429",
    stroke: "url(#paint3_linear_26951_23032)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.286 108.857V64.2856C145.286 60.183 141.96 56.8571 137.857 56.8571H100.714C96.6116 56.8571 93.2856 60.183 93.2856 64.2856V108.857C93.2856 112.96 96.6116 116.286 100.714 116.286H137.857C141.96 116.286 145.286 112.96 145.286 108.857Z",
    stroke: "url(#paint4_linear_26951_23032)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5715 27.1428H56.1429C52.0402 27.1428 48.7144 30.4687 48.7144 34.5714V86.5714C48.7144 90.6742 52.0402 94 56.1429 94H78.4286",
    stroke: "url(#paint5_linear_26951_23032)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2856 27.1428H100.714C104.817 27.1428 108.143 30.4687 108.143 34.5714V42",
    stroke: "url(#paint6_linear_26951_23032)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26951_23032",
    x1: 145.727,
    y1: 34.8033,
    x2: 106.531,
    y2: 47.9961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26951_23032",
    x1: 92.9479,
    y1: 27.021,
    x2: 55.7698,
    y2: 52.0484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26951_23032",
    x1: 130.176,
    y1: 77.7774,
    x2: 129.468,
    y2: 83.0849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26951_23032",
    x1: 130.176,
    y1: 96.3489,
    x2: 129.468,
    y2: 101.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26951_23032",
    x1: 144.695,
    y1: 86.0842,
    x2: 57.6955,
    y2: 111.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26951_23032",
    x1: 78.091,
    y1: 60.0234,
    x2: 25.2476,
    y2: 67.9285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26951_23032",
    x1: 107.974,
    y1: 34.4496,
    x2: 83.7099,
    y2: 42.6166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselItem2);
export default __webpack_public_path__ + "static/media/carousel_item_2.52a0d84f41cf4ddfcf7137259f272386.svg";
export { ForwardRef as ReactComponent };